/**
 * Indicates whether or not to exchange for phsyical.
 * tag: 411
 * @readonly
 * @enum {string} (Boolean)
 */
export enum ExchangeForPhysical {
  /** False */
  False = 'N',
  /** True */
  True = 'Y',
}
